import type { PropsWithChildren } from 'react';
import React from 'react';
import { useSelector } from 'react-redux';

import { isCAP as isCAPSelector } from 'selectors';

const IsCAP = ({ children }: PropsWithChildren<unknown>) => {
  const isCap = useSelector(isCAPSelector);
  return isCap ? <>{children}</> : null;
};

export { IsCAP };
